export function saveSession(token, user) {
  localStorage.setItem('kts_invoice_token', token);
  localStorage.setItem('kts_invoice_user', JSON.stringify(user));
}

export function getUser() {
  const raw = localStorage.getItem('kts_invoice_user');
  return raw ? JSON.parse(raw) : null;
}

export function getToken() {
  return localStorage.getItem('kts_invoice_token');
}

export function clearSession() {
  localStorage.removeItem('kts_invoice_token');
  localStorage.removeItem('kts_invoice_user');
}

export function isAuthenticated() {
  return !!getToken();
}
